/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomEliteConfigurationModelDto } from '../../models/custom-elite-configuration-model-dto';

export interface CustomEliteConfigurationControllerGetConfigurations$Params {
}

export function customEliteConfigurationControllerGetConfigurations(http: HttpClient, rootUrl: string, params?: CustomEliteConfigurationControllerGetConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomEliteConfigurationModelDto>>> {
  const rb = new RequestBuilder(rootUrl, customEliteConfigurationControllerGetConfigurations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomEliteConfigurationModelDto>>;
    })
  );
}

customEliteConfigurationControllerGetConfigurations.PATH = '/custom-elite-configuration';
